import { RedoMerchantClient } from "../client";

/**
 * POST /support/parse-email-signature
 */
export async function parseEmailSignature(
  client: RedoMerchantClient,
  { html, signal }: { html: string; signal?: AbortSignal },
) {
  const response = await client.client.post(
    "support/parse-email-signature",
    { html },
    { headers: client.authorization(), signal },
  );
  return response.data;
}
